import { Grid, Heading, InnerSiteLayout } from "@msuite/picasso";
import type { FC } from "react";
import { ConstructionSitesInvoicesChart } from "./construction-sites-invoices-chart";

export const ConstructionSitesDashboard: FC = () => {
	/** Render */
	return (
		<InnerSiteLayout>
			<Heading>Dashboard</Heading>
			<Grid
				gridTemplateColumns="repeat(3, 1fr)"
				gridAutoRows="400px"
				gap={6}
			>
				<ConstructionSitesInvoicesChart />
			</Grid>
		</InnerSiteLayout>
	);
};
